import i18n from '@services/i18n';
import * as yup from 'yup';

import { PrivacyPolicyModel } from '../create/createPrivacyPolicy';
import {
  MAX_SIZE_BYTES,
  PDF_ALLOWED_EXTENSIONS
} from './privacyPolicyDetailFormConstraints';

export interface PrivacyPolicyDetailFormModel {
  pdfFile: PrivacyPolicyModel['data'];
}

const validateMaxSizeError = (value: FileList): value is FileList => {
  return !value || !value.length || value[0].size < MAX_SIZE_BYTES;
};

const maxSizeErrorMessage = () => (
  params?: Partial<yup.TestMessageParams>
): string =>
  i18n.t('fieldValidations.custom.fileMaxSize', {
    ...params,
    label: i18n.t('privacy-policy:fieldNames.pdf'),
    maxKb: MAX_SIZE_BYTES / 1024
  });

const validateFileTypeError = (value: FileList): value is FileList => {
  return (
    !value ||
    !value.length ||
    PDF_ALLOWED_EXTENSIONS.some((t) => t === value[0].type)
  );
};

const fileTypeErrorMessage = () => (
  params?: Partial<yup.TestMessageParams>
): string =>
  i18n.t('fieldValidations.mixed.notType', {
    ...params,
    label: i18n.t('privacy-policy:fieldNames.pdf')
  });

const privacyPolicyDetailFormSchema = yup
  .object<PrivacyPolicyDetailFormModel>()
  .shape({
    pdfFile: yup
      .mixed()
      .test('validSize', maxSizeErrorMessage(), validateMaxSizeError)
      .test('validType', fileTypeErrorMessage(), validateFileTypeError)
      .required()
  });

export { privacyPolicyDetailFormSchema };
